// VerifyLastName.js
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import { fetchLastNameVerification } from "./../services/apiServices";
import fetchSmartReportData from "./../services/apiServices";
import logo from '../assets/images/logo.png';
import SimpleCaptcha from './../components/captcha'; 

function encodeBase64(data) {
    return btoa(data); // Encoding lab number and last name in base64 format
}
function decodeBase64(encodedData) {
    return decodeURIComponent(escape(atob(encodedData))); // Decode and handle special characters
}

const VerifyLastName = () => {   

    const [lastName, setLastName] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isCaptchaValid, setIsCaptchaValid] = useState(false);
    const navigate = useNavigate();
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const labNumber = queryParams.get('lno');

    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!isCaptchaValid) {
            setError("Please solve the CAPTCHA correctly.");
            return;
        }

        setLoading(true);

        lastName.trim();
        // const trimmedLastName = lastName.trim();
        // if (!trimmedLastName) {
        //     setError("Enter a valid last name.");
        //     setLoading(false);
        //     return;
        // }
        try {
            if (lastName) {
                const verificationData = await fetchSmartReportData(labNumber, encodeBase64(lastName));                
                if (!verificationData.IsSuccess || !verificationData.data || verificationData.data === " " || verificationData.data === "undefined") {
                    setError("Password verification failed. Please enter a correct password.");
                } else {
                    navigate('/report', {
                        state: {
                          labNumber: encodeBase64(labNumber),
                          lastName: encodeBase64(lastName)
                        }
                    });
                }
            }
        } catch (err) {
            setError("An error occurred while verifying. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid">
            <div className="card-center-wrapper">
                <div className="card-center">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-10 col-sm-8 col-md-4 col-lg-3">
                            <div className="card border-0  my-3">
                                <div className="card-body">
                                    <div className="text-center mb-3">
                                        <img className="search-logo" alt="Logo" src={logo} />
                                    </div>
                                    <h2 className="smart-title text-center mb-5">Smart Report</h2>

                                    <form onSubmit={handleSubmit}>
                                        <div className="form-floating mb-3">
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="lastName"
                                                value={lastName}
                                                onChange={(e) => setLastName(e.target.value)}
                                                required
                                                placeholder=""
                                                autoComplete="new-password"
                                            />
                                            <label htmlFor="lastName">Password</label>
                                        </div>
                                        <div className="form-floating  mb-3">
                                             <SimpleCaptcha onValidate={setIsCaptchaValid} />
                                            {/* {error && <div className="text-danger ">{error}</div>} */}
                                        </div>
                                        <div className="mt-2 mb-3" style={{fontSize: '10px', color : '#4c4c4c'}}>
                                                <span style={{color: '#e70b0b'}}>*</span> Your last name is the password. For e.g. - If <span style={{fontWeight:'700', color: '#3a3a3a'}}>Gaurav Sharma</span> is the patient name, then your password is <span style={{fontWeight:'700', color: '#3a3a3a'}}>Sharma</span>.
                                                </div>

                                        {error && <div className="text-danger mb-3">{error}</div>}

                                        
                                        <button className="btn btn-primary w-100 mt-3" type="submit" disabled={loading}>
                                            {loading ? "Verifying..." : "Verify"}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyLastName;
